"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function isZapOff({ paused }) {
    return lodash_1.isNil(paused) || paused;
}
exports.default = isZapOff;
